/**
 * store/helpers.ts
 * دوال مساعدة لمتجر الطقس: تطبيع خط الطول، والإغلاق المتبادل للّوحات.
 */

export function normalizeLongitude(value: number): number {
    return ((((value + 180) % 360) + 360) % 360) - 180;
}

export type ResponsivePanelKey =
    'sidebarOpen' | 'layerControlsOpen' | 'infoPanelOpen' | 'settingsOpen' | 'modalOpen'
    | 'cycloneDockOpen';

/* نقطة التوقّف المدمجة — يجب أن تطابق `max-[768px]` في الـ JSX و`max-width: 1180px`
   في 27-responsive-mobile.css و22-layer-sidebar.css و14-cyclone.css. رقمٌ واحد يقرّر
   التخطيط والسلوك معاً: لو افترقا صار الشريط يبدو جوّالاً ويتصرّف كسطح مكتب (أو العكس)،
   وهو عطبٌ صامت لأن كلّاً منهما صحيح على حدة. */
export function isCompactViewport(): boolean {
    return typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
}

/** فتح لوحة يُغلق البقية في كل المقاسات، كي لا تتراكب لوحتان فوق الخريطة. */
export function getResponsivePanelPatch(
    panel: ResponsivePanelKey,
): Partial<Record<ResponsivePanelKey, boolean>> {
    return {
        sidebarOpen: false,
        layerControlsOpen: false,
        infoPanelOpen: false,
        settingsOpen: false,
        modalOpen: false,
        cycloneDockOpen: false,
        [panel]: true,
    };
}

/** قائمة التراكبات السريعة محلية في مكوّنها، لذا تُغلق بإشارة خفيفة من المتجر. */
export function closeOverlayQuickPanel(): void {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('rasid:close-overlay-quick'));
    }
}
